module.exports = __webpack_public_path__ + "img/logo.a33372f2.png";